._1az3m6w0 {
  min-width: 400px;
}
._1az3m6w1 {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 16px;
}
._1az3m6w2 {
  display: flex;
  flex-direction: column;
  margin-right: auto;
  min-width: 0;
  gap: 3px;
  margin-bottom: 8px;
}
._1az3m6w3 {
  font-size: 18px;
  margin-right: 8px;
  flex-shrink: 0;
  color: var(--_6225er1);
}
._1az3m6w4 {
  margin: 0;
  font-size: var(--_6225er1v);
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
._1az3m6w5 {
  display: block;
  width: auto;
  height: 26px;
  object-fit: contain;
}
._1az3m6w6 {
  font-size: var(--_6225er1z);
  font-weight: var(--_6225er20);
}
._1az3m6w7 {
  color: var(--_6225er1);
  cursor: pointer;
  transition: color 0.2s;
}
._1az3m6w7:hover {
  color: var(--_6225er2);
}
._1az3m6w8 {
  padding: 13px;
  background-color: var(--_6225er10);
  color: var(--_6225er4);
  border-radius: var(--_6225erx);
  box-shadow: var(--_6225erq);
  position: absolute;
  display: flex;
  flex-direction: column;
  z-index: 2;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
._1az3m6w9 {
  font-size: var(--_6225er1t);
  font-weight: var(--_6225er1u);
  margin-bottom: 13px;
}
._1az3m6wa {
  color: var(--_6225er1);
}
._1az3m6wb {
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: var(--_6225erb) transparent;
  position: relative;
}
._1az3m6wc {
  padding: 12px 11px;
  background-color: var(--_6225erd);
  border-radius: var(--_6225erw);
  font-size: 14px;
  font-weight: var(--_6225er26);
  cursor: pointer;
  transition: background-color 0.2s;
}
._1az3m6wc:hover {
  background-color: var(--_6225era);
}